module.exports = __webpack_public_path__ + "img/ic_discipline_specialties.686e5319.svg";